import {h} from 'preact';
import constants from "../constants";
import {CopilotView} from "./MenuCopilot";

interface MenuCopilotOverviewProps {
  visible: boolean;
  isPaidMember: boolean;
  setView: (view: CopilotView) => void;
  setActiveMember: () => void;
  isPrintable: boolean;
  limitExceeded: boolean;
}

export default function MenuCopilotOverview({
                                              visible,
                                              setView,
                                              isPaidMember,
                                              setActiveMember,
                                              isPrintable,
                                              limitExceeded
                                            }: MenuCopilotOverviewProps) {


  function goTo(view: CopilotView) {
    if (!isPaidMember) {
      //@ts-ignore
      window.MHM.ProModal.upgrade({memberId: window.data.member.id, onSuccess: setActiveMember});
      return;
    }

    if (limitExceeded) {
      return;
    }
    setView(view);
  }


  return <section className={`bot-section ${visible ? "visible" : ""}`}>
    <ul className={`overview ${limitExceeded ? "limit" : ""}`}>
      <li>
        <button onClick={() => goTo(CopilotView.SpellCheck)}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#spellcheck"}/>
          </svg>
          <div>
            <h5>Spell Check <div className={"beta"}>Beta</div></h5>
            <span>Find and replace misspellings</span>
          </div>
          {!isPaidMember && <div className="pro">
            <img alt="star" src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg"/>
          </div>}
        </button>
      </li>

      {isPrintable && <li>
        <button onClick={() => goTo(CopilotView.PrintCheck)}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#printcheck"}/>
          </svg>
          <div>
            <h5>Print Check <div className={"beta"}>Beta</div></h5>
            <span>Make sure your design is print-ready</span>
          </div>
          {!isPaidMember && <div className="pro">
            <img alt="star" src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg"/>
          </div>}
        </button>
      </li>}

      <li>
        <button onClick={() => goTo(CopilotView.DesignTips)}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#designtips"}/>
          </svg>
          <div>
            <h5>Design Tips <div className={"beta"}>Beta</div></h5>
            <span>Expert tips to make your design stand out</span>
          </div>
          {!isPaidMember && <div className="pro">
            <img alt="star" src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg"/>
          </div>}
        </button>
      </li>
    </ul>
  </section>
}
